export default __webpack_public_path__ + "static/media/logowhite.f5a32725.png";